<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!-- Users -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div class="card-title">
                  <h5 class="float-left">Users</h5>
                  <b-button
                    variant="primary"
                    class="btn btn-label btn-primary float-right"
                    v-b-modal.modal_addUser
                    ><i class="bx bx-plus label-icon"></i>Add User</b-button
                  >
                  <!-- Add User modal -->
                  <b-modal
                    id="modal_addUser"
                    title="Add User"
                    title-class="font-18"
                    ok-title=""
                    @ok="addUser"
                    @close="clearAddUserModal"
                    @cancel="clearAddUserModal"
                  >
                    <div class="mb-4">
                      <div class="form-group">
                        <label>Name</label>
                        <b-form-input
                          placeholder="Name..."
                          v-model="addUser_name"
                          :class="{ 'is-invalid': addUser_errors.nameError }"
                        ></b-form-input>
                        <div
                          v-if="addUser_errors.nameError"
                          class="invalid-feedback"
                        >
                          <span>{{ addUser_errors.nameMessage }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="mb-4">
                      <div class="form-group">
                        <label>Email</label>
                        <b-form-input
                          placeholder="Email..."
                          v-model="addUser_email"
                          :class="{ 'is-invalid': addUser_errors.emailError }"
                        ></b-form-input>
                        <div
                          v-if="addUser_errors.emailError"
                          class="invalid-feedback"
                        >
                          <span>{{ addUser_errors.emailMessage }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="mb-4">
                      <div class="form-group">
                        <label>Confirm Email</label>
                        <b-form-input
                          placeholder="Confirm email..."
                          v-model="addUser_confirmEmail"
                          :class="{
                            'is-invalid': addUser_errors.confirmEmailError,
                          }"
                        ></b-form-input>
                        <div
                          v-if="addUser_errors.confirmEmailError"
                          class="invalid-feedback"
                        >
                          <span>{{ addUser_errors.confirmEmailMessage }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="mt-4 mt-lg-0 mb-4">
                      <div class="form-group">
                        <label>Position</label>
                        <v-select
                          multiple
                          :options="positions"
                          label="position"
                          v-model="addUser_selectedPositions"
                          :class="{
                            'is-invalid ddl-is-invalid':
                              addUser_errors.positionsError,
                          }"
                        ></v-select>
                        <div
                          v-if="addUser_errors.positionsError"
                          class="invalid-feedback"
                        >
                          <span>{{ addUser_errors.positionsMessage }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="mb-4">
                      <div class="form-group">
                        <label>Employee Rate</label>
                        <b-form-input
                          placeholder="Employee Rate..."
                          v-model="addUser_payrollRate"
                          :class="{
                            'is-invalid': addUser_errors.payrollRateError,
                          }"
                        ></b-form-input>
                        <div
                          v-if="addUser_errors.payrollRateError"
                          class="invalid-feedback"
                        >
                          <span>{{ addUser_errors.payrollRateMessage }}</span>
                        </div>
                      </div>
                      <div class="mb-4">
                        <div class="form-group">
                          <label>Employee Overtime Rate</label>
                          <b-form-input
                            placeholder="Employee Overtime Rate..."
                            @input="separateInputFromPayroll('payrollOvertime')"
                            v-model="addUser_payrollOvertimeRate"
                            :class="{
                              'is-invalid':
                                addUser_errors.payrollOvertimeRateError,
                            }"
                          ></b-form-input>
                          <div
                            v-if="addUser_errors.payrollOvertimeRateError"
                            class="invalid-feedback"
                          >
                            <span>{{
                              addUser_errors.payrollOvertimeRateMessage
                            }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="mb-4">
                        <div class="form-group">
                          <label>Default Billable Rate</label>
                          <b-form-input
                            placeholder="Default Billable Rate..."
                            @input="separateInputFromPayroll('billable')"
                            v-model="addUser_billableRate"
                            :class="{
                              'is-invalid': addUser_errors.billableRateError,
                            }"
                          ></b-form-input>
                          <div
                            v-if="addUser_errors.billableRateError"
                            class="invalid-feedback"
                          >
                            <span>{{
                              addUser_errors.billableRateMessage
                            }}</span>
                          </div>
                        </div>
                      </div>

                      <div class="mb-4">
                        <div class="form-group">
                          <label>Default Overtime Rate</label>
                          <b-form-input
                            placeholder="Default Overtime Rate..."
                            @input="separateInputFromPayroll('overtime')"
                            v-model="addUser_overtimeRate"
                            :class="{
                              'is-invalid': addUser_errors.overtimeRateError,
                            }"
                          ></b-form-input>
                          <div
                            v-if="addUser_errors.overtimeRateError"
                            class="invalid-feedback"
                          >
                            <span>{{
                              addUser_errors.overtimeRateMessage
                            }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="mb-4">
                        <div class="form-group">
                          <label>Travel Rate</label>
                          <b-form-input
                            placeholder="Travel Rate..."
                            @input="separateInputFromPayroll('travel')"
                            v-model="addUser_travelTimeRate"
                            :class="{
                              'is-invalid': addUser_errors.travelTimeRateError,
                            }"
                          ></b-form-input>
                          <div
                            v-if="addUser_errors.travelTimeRateError"
                            class="invalid-feedback"
                          >
                            <span>{{
                              addUser_errors.travelTimeRateMessage
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <template #modal-footer>
                      <b-button
                        id="btn_search"
                        variant="primary"
                        @click="addUser"
                        class="btn btn-primary d-flex"
                      >
                        <i
                          v-if="loading === false"
                          class="add-user-icon bx bx-user-plus mr-2"
                          style="font-size: 20px"
                        ></i>
                        <spring-spinner
                          class="label-spinner mr-2"
                          v-else
                          :animation-duration="3000"
                          :size="20"
                          color="white"
                        />
                        Add User
                      </b-button>
                    </template>
                  </b-modal>
                  <!-- /Add User modal -->

                  <!-- Edit User Modal -->
                  <b-modal
                    id="modal_editUser"
                    title="Edit User"
                    title-class="font-18"
                    ok-title="Edit User"
                    @ok="editUser"
                    @close="clearEditUserModal"
                    @cancel="clearEditUserModal"
                    :editUser_name="editUser_name"
                  >
                    <div class="mb-4">
                      <div class="form-group">
                        <label>Name</label>
                        <b-form-input
                          placeholder="Name..."
                          v-model="editUser_name"
                          :class="{ 'is-invalid': editUser_errors.nameError }"
                        ></b-form-input>
                        <div
                          v-if="editUser_errors.nameError"
                          class="invalid-feedback"
                        >
                          <span>{{ editUser_errors.nameMessage }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="mb-4">
                      <div class="form-group">
                        <label>Email</label>
                        <b-form-input
                          placeholder="Email..."
                          v-model="editUser_email"
                          :class="{ 'is-invalid': editUser_errors.emailError }"
                        ></b-form-input>
                        <div
                          v-if="editUser_errors.emailError"
                          class="invalid-feedback"
                        >
                          <span>{{ editUser_errors.emailMessage }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="mb-4">
                      <div class="form-group">
                        <label>Confirm Email</label>
                        <b-form-input
                          placeholder="Confirm email..."
                          v-model="editUser_confirmEmail"
                          :class="{
                            'is-invalid': editUser_errors.confirmEmailError,
                          }"
                        ></b-form-input>
                        <div
                          v-if="editUser_errors.confirmEmailError"
                          class="invalid-feedback"
                        >
                          <span>{{ editUser_errors.confirmEmailMessage }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="mt-4 mt-lg-0 mb-4">
                      <div class="form-group">
                        <label>Position</label>
                        <v-select
                          multiple
                          :options="positions"
                          label="position"
                          v-model="editUser_selectedPositions"
                          :class="{
                            'is-invalid ddl-is-invalid':
                              editUser_errors.positionsError,
                          }"
                        ></v-select>
                        <div
                          v-if="editUser_errors.positionsError"
                          class="invalid-feedback"
                        >
                          <span>{{ editUser_errors.positionsMessage }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="mb-4">
                      <div class="form-group">
                        <label>Employee Rate</label>
                        <b-form-input
                          placeholder="Employee Rate..."
                          v-model="editUser_payrollRate"
                          :class="{
                            'is-invalid': editUser_errors.payrollRateError,
                          }"
                        ></b-form-input>
                        <div
                          v-if="editUser_errors.payrollRateError"
                          class="invalid-feedback"
                        >
                          <span>{{ editUser_errors.payrollRateMessage }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="mb-4">
                      <div class="form-group">
                        <label>Employee Overtime Rate</label>
                        <b-form-input
                          placeholder="Employee Overtime Rate..."
                          v-model="editUser_payrollOvertimeRate"
                          :class="{
                            'is-invalid':
                              editUser_errors.payrollOvertimeRateError,
                          }"
                        ></b-form-input>
                        <div
                          v-if="editUser_errors.payrollOvertimeRateError"
                          class="invalid-feedback"
                        >
                          <span>{{
                            editUser_errors.payrollOvertimeRateMessage
                          }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="mb-4">
                      <div class="form-group">
                        <label>Default Billable Rate</label>
                        <b-form-input
                          placeholder="Default Billable Rate..."
                          v-model="editUser_billableRate"
                          :class="{
                            'is-invalid': editUser_errors.billableRateError,
                          }"
                        ></b-form-input>
                        <div
                          v-if="editUser_errors.billableRateError"
                          class="invalid-feedback"
                        >
                          <span>{{ editUser_errors.billableRateMessage }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="mb-4">
                      <div class="form-group">
                        <label>Default Overtime Rate</label>
                        <b-form-input
                          placeholder="Default Overtime Rate..."
                          v-model="editUser_overtimeRate"
                          :class="{
                            'is-invalid': editUser_errors.overtimeRateError,
                          }"
                        ></b-form-input>
                        <div
                          v-if="editUser_errors.overtimeRateError"
                          class="invalid-feedback"
                        >
                          <span>{{ editUser_errors.overtimeRateMessage }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="mb-4">
                      <div class="form-group">
                        <label>Travel Rate</label>
                        <b-form-input
                          placeholder="Travel Rate..."
                          v-model="editUser_travelTimeRate"
                          :class="{
                            'is-invalid': editUser_errors.travelTimeRateError,
                          }"
                        ></b-form-input>
                        <div
                          v-if="editUser_errors.travelTimeRateError"
                          class="invalid-feedback"
                        >
                          <span>{{
                            editUser_errors.travelTimeRateMessage
                          }}</span>
                        </div>
                      </div>
                    </div>

                    <template #modal-footer>
                      <b-button
                        id="btn_search"
                        variant="primary"
                        @click="editUser"
                        class="btn btn-primary d-flex"
                      >
                        <i
                          v-if="loading === false"
                          class="bx bxs-edit-alt mr-2"
                          style="font-size: 20px"
                        ></i>
                        <spring-spinner
                          class="label-spinner mr-2"
                          v-else
                          :animation-duration="3000"
                          :size="20"
                          color="white"
                        />
                        Edit User
                      </b-button>
                    </template>
                  </b-modal>
                  <!-- /Edit User Modal -->
                </div>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-xl-12 col-lg-12 col-md-12">
                <div class="row mt-4">
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                          v-model="usersPerPage"
                          size="sm"
                          :options="usersPageOptions"
                        ></b-form-select
                        >&nbsp;entries
                      </label>
                    </div>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter text-md-right"
                    >
                      <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                          v-model="usersFilter"
                          type="search"
                          placeholder="Search..."
                          class="form-control form-control-sm ml-2"
                        ></b-form-input>
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <!-- Table -->
                <!--  -->
                <div
                  :style="usersTotalRows > usersPerPage
                    ? { minHeight: usersPerPage * 56 + 'px' }
                    : {}"
                >
                  <b-table
                    :items="usersTableData"
                    responsive="sm"
                    :fields="usersFields"
                    :per-page="usersPerPage"
                    :current-page="usersCurrentPage"
                    :sort-by.sync="usersSortBy"
                    :sort-desc.sync="usersSortDesc"
                    :filter="usersFilter"
                    :filter-included-fields="usersFilterOn"
                    @filtered="onFiltered"
                    style="text-align: center"
                  >
                    <template v-slot:cell(edit)="data">
                      <b-dropdown variant="primary" size="sm">
                        <template v-slot:button-content>
                          <i class="mdi mdi-chevron-down"></i>
                        </template>
                        <b-dropdown-item
                          v-b-modal.modal_editUser
                          @click="populateEditUser(data.index)"
                          ><i class="bx bx-pencil mr-2 tableIcons"></i
                          >Edit</b-dropdown-item
                        >
                        <b-dropdown-item
                          @click.native.capture.stop="
                            sendPasswordReset(data.item.email)
                          "
                        >
                          <div class="d-flex">
                            <i
                              v-if="loading === false"
                              class="bx bx-mail-send mr-2 tableIcons"
                            ></i>
                            <spring-spinner
                              class="label-spinner mr-2"
                              v-else
                              :animation-duration="3000"
                              :size="15"
                              color="#556de5"
                            />
                            Reset Password
                          </div>
                        </b-dropdown-item>
                        <b-dropdown-item @click.native.capture.stop="deactivateUser(data.item.edit)">
                          <div class="d-flex">
                            <i v-if="deleteUserLoading === false" class="bx bx-trash mr-2 tableIcons"></i>
                            <spring-spinner
                              class="label-spinner mr-2"
                              v-else
                              :animation-duration="3000"
                              :size="15"
                              color="#556de5"
                            />
                            Delete
                          </div>
                          </b-dropdown-item
                        >
                      </b-dropdown>
                    </template>
                    <template v-slot:cell(position)="data">
                      <div>
                        <a
                          v-for="pos in data.item.position"
                          :key="pos"
                          href="javascript: void(0);"
                          class="badge badge-primary font-size-11 mr-2"
                        >
                          {{ pos }}
                        </a>
                      </div>
                    </template>
                  </b-table>
                </div>
                <div class="row">
                  <div class="col">
                    <div
                      class="dataTables_paginate paging_simple_numbers float-right"
                    >
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                          v-model="usersCurrentPage"
                          :total-rows="usersTotalRows"
                          :per-page="usersPerPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <!--/Row-->
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
    </div>
    <!-- end row -->

    <!-- Customers -->
    <div class="row">
      <div class="col-lg-12">
        <Sidepanel
          ref="collectionsSidePanel"
          @updateCollectionSelection="updateCollectionSelection"
          :showSavePopup="showSavePopup"
          @sidepanelPopupSave="sidepanelPopupSave"
          @sidePanelSwalPopupCancel="sidePanelSwalPopupCancel"
        />
        <CollectionTable
          :collectionName="collectionSelection"
          :tableData="customersTableData"
          :tableHeaders="customersFields"
          :totalRows="customersTotalRows"
          @deleteCollectionItem="deleteCollectionItem"
          @addCollectionItem="addCollectionItem"
          @deleteCollection="deleteCollection"
          @popUpHandler="popUpHandler"
          ref="collectionTableChild"
        />

        <!-- end card -->
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Vue from 'vue';
import Layout from '../../../layouts/main';
import PageHeader from '@/components/page-header';
import appConfig from '@/app.config';
import routes from '../../../routes.js';
import axios from 'axios';
import Swal from 'sweetalert2';
import Sidepanel from './sidepanel';
import CollectionTable from './collectionTable.vue';
import VueToast from 'vue-toast-notification';
import { SpringSpinner } from 'epic-spinners';

import 'vue-toast-notification/dist/theme-sugar.css';

Vue.use(VueToast);

import {
  getEmployees,
  getPositions,
  getCustomers,
  validateEmail,
  addCustomer,
  updateSageIntegrationDetails,
  updateQBOIntegrationDetails,
  syncQBCustomers,
  getCustomCollectionData,
  addCustomCollectionItem,
  deleteCustomCellection,
} from '../helper/dbHelpers.js';
import { parseBoolFromString } from '../helper/helpers.js';
import firebase from 'firebase';
import { firestore, auth } from 'firebase';
import { customStateMethods } from '@/state/helpers';

export default {
  page: {
    title: 'Users & App Data',
    meta: [{ name: 'Users & App Data', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    // ContentLoader,
    Sidepanel,
    CollectionTable,
    SpringSpinner,
  },
  data() {
    return {
      canceledSideBarPopup: false,
      showSavePopup: false,
      dragDropMoved: false,
      dragging: false,
      title: 'Users & App Data',
      name: 'Users & App Data',
      items: [
        {
          text: 'home',
          href: '/',
        },
        {
          text: 'Users & App Data',
          href: '/production/admin',
          active: true,
        },
      ],
      routes: routes,
      usersPerPage: 10,
      usersTotalRows: 1,
      usersCurrentPage: 1,
      usersPageOptions: [10, 25, 50, 100],
      usersFilter: null,
      usersFilterOn: [],
      usersSortBy: 'name',
      usersSortDesc: false,
      usersFields: [
        { key: 'edit' },
        { key: 'employee' },
        { key: 'email' },
        { key: 'position' },
        { key: 'payrollRate', label: 'Employee Rate' },
        {
          key: 'payrollOvertimeRate',
          label: 'Employee Overtime Rate',
        },
        { key: 'billableRate' },
        {
          key: 'overtimeRate',
          label: 'Billable Overtime Rate',
        },
        {
          key: 'travelTimeRate',
          label: 'Travel Rate',
        },
      ],
      usersTableData: [],
      currentUser: this.$store.state.custom.currentUserData,
      customersPerPage: 10,
      customersTotalRows: 1,
      customersCurrentPage: 1,
      customersPageOptions: [10, 25, 50, 100],
      customersFilter: null,
      customersFilterOn: [],
      customersSortBy: 'name',
      customersSortDesc: false,
      customersFields: [
        { key: 'edit', label: '', sortable: false },
        { key: 'name', sortable: true },
        { key: 'source', sortable: true },
      ],
      customersTableData: [],
      addUser_billableFlag: false,
      addUser_overtimeFlag: false,
      addUser_travelFlag: false,
      addUser_overtimeRate: null,
      addUser_travelTimeRate: null,
      addUser_billableRate: null,
      addUser_payrollRate: null,
      addUser_payrollOvertimeRate: null,
      addUser_name: null,
      addUser_email: null,
      addUser_confirmEmail: null,
      addUser_selectedPositions: [],
      addUser_errors: {
        nameError: false,
        nameMessage: null,
        emailError: false,
        emailMessage: null,
        confirmEmailError: false,
        confirmEmailMessage: null,
        positionsError: false,
        positionsMessage: null,
        billableRateError: false,
        billableRateMessage: null,
        overtimeRateError: false,
        overtimeRateMessage: null,
        travelTimeRateError: false,
        travelTimeRateMessage: null,
        payrollRateError: false,
        payrollRateMessage: null,
        payrollOvertimeRateError: false,
        payrollOvertimeRateMessage: null,
      },
      editUser_ID: null,
      editUser_overtimeRate: null,
      editUser_travelTimeRate: null,
      editUser_billableRate: null,
      editUser_payrollRate: null,
      editUser_payrollOvertimeRate: null,

      editUser_name: null,
      editUser_email: null,
      editUser_confirmEmail: null,
      editUser_selectedPositions: [],
      editUser_errors: {
        nameError: false,
        nameMessage: null,
        emailError: false,
        emailMessage: null,
        confirmEmailError: false,
        confirmEmailMessage: null,
        positionsError: false,
        positionsMessage: null,
        billableRateError: false,
        billableRateMessage: null,
        overtimeRateError: false,
        overtimeRateMessage: null,
        travelTimeRateError: false,
        travelTimeRateMessage: null,
        payrollRateError: false,
        payrollRateMessage: null,
        payrollOvertimeRateError: false,
        payrollOvertimeRateMessage: null,
      },
      addCustomer_name: null,
      addCustomer_errors: {
        customerError: false,
        customerMessage: null,
      },
      editCustomer_id: null,
      editCustomer_index: null,
      editCustomer_name: null,
      editCustomer_errors: {
        customerError: false,
        customerMessage: null,
      },
      positions: [],
      timeOutCounter: 0,
      collectionSelection: {
        id: null,
        name: 'Customers',
      },
      loading: false,
      deleteUserLoading: false,
    };
  },
  methods: {
    ...customStateMethods,
    addUser: function (bvModalEvt) {
      this.loading = true;
      if (this.validateAddUser()) {
        let request = {
          name: `${this.addUser_name}`,
          email: `${this.addUser_email}`,
          position: `${this.addUser_selectedPositions}`,
          payrollRate: `${this.addUser_payrollRate}`,
          payrollOvertimeRate: `${this.addUser_payrollOvertimeRate}`,
          rate: `${this.addUser_billableRate}`,
          overtimeRate: `${this.addUser_overtimeRate}`,
          travelTimeRate: `${this.addUser_travelTimeRate}`,
          org: sessionStorage.getItem('org'),
        };
        axios
          .get('https://us-central1-kali-45420.cloudfunctions.net/createUser', {
            // axios
            //   .get('http://localhost:5000/kali-45420/us-central1/createUser', {
            params: {
              request,
            },
          })
          .then((response) => {
            if (response.status == 200) {
              this.usersTableData.push({
                edit: response.data.uid,
                employee: this.addUser_name,
                position: this.addUser_selectedPositions,
                payrollRate: this.addUser_payrollRate,
                payrollOvertimeRate: this.addUser_payrollOvertimeRate,
                billableRate: this.addUser_billableRate,
                overtimeRate: this.addUser_overtimeRate,
                travelTimeRate: this.addUser_travelTimeRate,
                email: this.addUser_email,
              });
              this.usersTotalRows = this.usersTableData.length
              Swal.fire('Success!', 'User added successfully.', 'success');
              this.loading = false;
              this.clearAddUserModal();
              this.$bvModal.hide('modal_addUser');
            } else {
              this.loading = false;
              Swal.fire('Error!', 'An unhandled error occurred! 🤔', 'error');
            }
          })
          .catch((err) => {
            this.loading = false;
            console.log(`Error calling the add user function: ${err}`);
            Swal.fire('Error!', err.response.data.response, 'error');
          });
      } else {
        this.loading = false;
        bvModalEvt.preventDefault();
      }
    },
    sidepanelPopupSave(payload) {
      if (payload) {
        this.$refs.collectionTableChild.updateDatabaseWithDraggableArray();
      }
    },
    popUpHandler(payload) {
      this.showSavePopup = payload;
    },
    dragChanged() {
      this.dragDropMoved = true;
    },
    preventPageRefresh: function (e) {
      if (this.showSavePopup) {
        if (!this.canceledSideBarPopup) {
          e.preventDefault();
          e.stopPropagation();
          e.returnValue = '';
        }
      }
    },
    sidePanelSwalPopupCancel: function (payload) {
      this.canceledSideBarPopup = payload;
      this.showSavePopup = false;
    },
    validateAddUser: function () {
      let flag = true;
      //check to make sure the name isn't empty
      if (this.addUser_name == null || this.addUser_name.trim() == '') {
        this.addUser_errors.nameError = true;
        this.addUser_errors.nameMessage = 'Value cannot be empty.';
        flag = false;
      } else {
        this.addUser_errors.nameError = false;
        this.addUser_errors.nameMessage = null;
      }
      //check to make syre the email isn't empty and the confirm box value matches
      if (this.addUser_email == null || this.addUser_email.trim() == '') {
        this.addUser_errors.emailError = true;
        this.addUser_errors.emailMessage = 'Value cannot be empty.';
        flag = false;
      } else {
        if (validateEmail(this.addUser_email.trim())) {
          this.addUser_errors.emailError = false;
          this.addUser_errors.emailMessage = null;
        } else {
          this.addUser_errors.emailError = true;
          this.addUser_errors.emailMessage = 'Value is not a valid email.';
          flag = false;
        }
      }
      //check that the confirm box isn't empty.
      if (
        this.addUser_confirmEmail == null ||
        this.addUser_confirmEmail.trim() == ''
      ) {
        this.addUser_errors.confirmEmailError = true;
        this.addUser_errors.confirmEmailMessage = 'Value cannot be empty.';
        flag = false;
      } else {
        this.addUser_errors.confirmEmailError = false;
        this.addUser_errors.confirmEmailMessage = null;
      }
      if (this.addUser_confirmEmail != null && this.addUser_email != null) {
        if (this.addUser_email.trim() != this.addUser_confirmEmail.trim()) {
          this.addUser_errors.emailError = true;
          this.addUser_errors.confirmEmailError = true;
          this.addUser_errors.emailMessage = 'Emails do not match.';
          this.addUser_errors.confirmEmailMessage = 'Emails do not match.';
          flag = false;
        }
      }
      //check to make sure at least one positio has been selected.
      if (this.addUser_selectedPositions.length == 0) {
        this.addUser_errors.positionsError = true;
        this.addUser_errors.positionsMessage = 'Value cannot be empty.';
        flag = false;
      } else {
        this.addUser_errors.positionsError = false;
        this.addUser_errors.positionsMessage = null;
      }
      //check to make sure the payroll rate isn't empty and is a number.
      if (
        this.addUser_payrollRate == null ||
        this.addUser_payrollRate.trim() == ''
      ) {
        this.addUser_errors.payrollRateError = true;
        this.addUser_errors.payrollRateMessage = 'Value cannot be empty.';
        flag = false;
      } else if (isNaN(Number(this.addUser_payrollRate.trim()))) {
        this.addUser_errors.payrollRateError = true;
        this.addUser_errors.payrollRateMessage = 'Value is not a decimal.';
        flag = false;
      } else {
        this.addUser_errors.payrollRateError = false;
        this.addUser_errors.payrollRateMessage = null;
      }
      //check to make sure the overtime payroll rate isn't empty and is a number.
      if (
        this.addUser_payrollOvertimeRate == null ||
        this.addUser_payrollOvertimeRate.trim() == ''
      ) {
        this.addUser_errors.payrollOvertimeRateError = true;
        this.addUser_errors.payrollOvertimeRateMessage =
          'Value cannot be empty.';
        flag = false;
      } else if (isNaN(Number(this.addUser_payrollOvertimeRate.trim()))) {
        this.addUser_errors.payrollOvertimeRateError = true;
        this.addUser_errors.payrollOvertimeRateMessage =
          'Value is not a decimal.';
        flag = false;
      } else {
        this.addUser_errors.payrollOvertimeRateError = false;
        this.addUser_errors.payrollOvertimeRateMessage = null;
      }
      //check to make sure the rate isn't empty and is a number.
      if (
        this.addUser_billableRate == null ||
        this.addUser_billableRate.trim() == ''
      ) {
        this.addUser_errors.billableRateError = true;
        this.addUser_errors.billableRateMessage = 'Value cannot be empty.';
        flag = false;
      } else if (isNaN(Number(this.addUser_billableRate.trim()))) {
        this.addUser_errors.billableRateError = true;
        this.addUser_errors.billableRateMessage = 'Value is not a decimal.';
        flag = false;
      } else {
        this.addUser_errors.billableRateError = false;
        this.addUser_errors.billableRateMessage = null;
      }
      //check to make sure the overtime rate isn't empty and is a number.

      if (
        this.addUser_overtimeRate == null ||
        this.addUser_overtimeRate.trim() == ''
      ) {
        this.addUser_errors.overtimeRateError = true;
        this.addUser_errors.overtimeRateMessage = 'Value cannot be empty.';
        flag = false;
      } else if (isNaN(Number(this.addUser_overtimeRate.trim()))) {
        this.addUser_errors.overtimeRateError = true;
        this.addUser_errors.overtimeRateMessage = 'Value is not a decimal.';
        flag = false;
      } else {
        this.addUser_errors.overtimeRateError = false;
        this.addUser_errors.overtimeRateMessage = null;
      }
      //check to make sure the overtime rate isn't empty and is a number.

      if (
        this.addUser_travelTimeRate == null ||
        this.addUser_travelTimeRate.trim() == ''
      ) {
        this.addUser_errors.travelTimeRateError = true;
        this.addUser_errors.travelTimeRateMessage = 'Value cannot be empty.';
        flag = false;
      } else if (isNaN(Number(this.addUser_travelTimeRate.trim()))) {
        this.addUser_errors.travelTimeRateError = true;
        this.addUser_errors.travelTimeRateMessage = 'Value is not a decimal.';
        flag = false;
      } else {
        this.addUser_errors.travelTimeRateError = false;
        this.addUser_errors.travelTimeRateMessage = null;
      }
      return flag;
    },
    validateEditUser: function () {
      let flag = true;
      //check to make sure the name isn't empty
      if (this.editUser_name == null || this.editUser_name.trim() == '') {
        this.editUser_errors.nameError = true;
        this.editUser_errors.nameMessage = 'Value cannot be empty.';
        flag = false;
      } else {
        this.editUser_errors.nameError = false;
        this.editUser_errors.nameMessage = null;
      }
      //check to make syre the email isn't empty and the confirm box value matches
      if (this.editUser_email == null || this.editUser_email.trim() == '') {
        this.editUser_errors.emailError = true;
        this.editUser_errors.emailMessage = 'Value cannot be empty.';
        flag = false;
      } else {
        if (validateEmail(this.editUser_email.trim())) {
          this.editUser_errors.emailError = false;
          this.editUser_errors.emailMessage = null;
        } else {
          this.editUser_errors.emailError = true;
          this.editUser_errors.emailMessage = 'Value is not a valid email.';
          flag = false;
        }
      }
      //check that the confirm box isn't empty.
      if (
        this.editUser_confirmEmail == null ||
        this.editUser_confirmEmail.trim() == ''
      ) {
        this.editUser_errors.confirmEmailError = true;
        this.editUser_errors.confirmEmailMessage = 'Value cannot be empty.';
        flag = false;
      } else {
        this.editUser_errors.confirmEmailError = false;
        this.editUser_errors.confirmEmailMessage = null;
      }
      if (this.editUser_confirmEmail != null && this.editUser_email != null) {
        if (this.editUser_email.trim() != this.editUser_confirmEmail.trim()) {
          this.editUser_errors.emailError = true;
          this.editUser_errors.confirmEmailError = true;
          this.editUser_errors.emailMessage = 'Emails do not match.';
          this.editUser_errors.confirmEmailMessage = 'Emails do not match.';
          flag = false;
        }
      }
      //check to make sure at least one positio has been selected.
      if (this.editUser_selectedPositions.length == 0) {
        this.editUser_errors.positionsError = true;
        this.editUser_errors.positionsMessage = 'Value cannot be empty.';
        flag = false;
      } else {
        this.editUser_errors.positionsError = false;
        this.editUser_errors.positionsMessage = null;
      }
      //check to make sure the payroll rate isn't empty and is a number.
      if (
        this.editUser_payrollRate == null ||
        this.editUser_payrollRate.trim() == ''
      ) {
        this.editUser_errors.payrollRateError = true;
        this.editUser_errors.payrollRateMessage = 'Value cannot be empty.';
        flag = false;
      } else if (isNaN(Number(this.editUser_payrollRate.trim()))) {
        this.editUser_errors.payrollRateError = true;
        this.editUser_errors.payrollRateMessage = 'Value is not a decimal.';
        flag = false;
      } else {
        this.editUser_errors.payrollRateError = false;
        this.editUser_errors.payrollRateMessage = null;
      }
      //check to make sure the payroll overtime rate isn't empty and is a number.
      if (
        this.editUser_payrollOvertimeRate == null ||
        this.editUser_payrollOvertimeRate.trim() == ''
      ) {
        this.editUser_errors.payrollOvertimeRateError = true;
        this.editUser_errors.payrollOvertimeRateMessage =
          'Value cannot be empty.';
        flag = false;
      } else if (isNaN(Number(this.editUser_payrollOvertimeRate.trim()))) {
        this.editUser_errors.payrollOvertimeRateError = true;
        this.editUser_errors.payrollOvertimeRateMessage =
          'Value is not a decimal.';
        flag = false;
      } else {
        this.editUser_errors.payrollOvertimeRateError = false;
        this.editUser_errors.payrollOvertimeRateMessage = null;
      }
      //check to make sure the rate isn't empty and is a number.
      if (
        this.editUser_billableRate == null ||
        this.editUser_billableRate.trim() == ''
      ) {
        this.editUser_errors.billableRateError = true;
        this.editUser_errors.billableRateMessage = 'Value cannot be empty.';
        flag = false;
      } else if (isNaN(Number(this.editUser_billableRate.trim()))) {
        this.editUser_errors.billableRateError = true;
        this.editUser_errors.billableRateMessage = 'Value is not a decimal.';
        flag = false;
      } else {
        this.editUser_errors.billableRateError = false;
        this.editUser_errors.billableRateMessage = null;
      }
      //check to make sure the overtime rate isn't empty and is a number.
      if (
        this.editUser_overtimeRate == null ||
        this.editUser_overtimeRate.trim() == ''
      ) {
        this.editUser_errors.overtimeRateError = true;
        this.editUser_errors.overtimeRateMessage = 'Value cannot be empty.';
        flag = false;
      } else if (isNaN(Number(this.editUser_overtimeRate.trim()))) {
        this.editUser_errors.overtimeRateError = true;
        this.editUser_errors.overtimeRateMessage = 'Value is not a decimal.';
        flag = false;
      } else {
        this.editUser_errors.overtimeRateError = false;
        this.editUser_errors.overtimeRateMessage = null;
      }
      //check to make sure the overtime rate isn't empty and is a number.
      if (
        this.editUser_travelTimeRate == null ||
        this.editUser_travelTimeRate.trim() == ''
      ) {
        this.editUser_errors.travelTimeRateError = true;
        this.editUser_errors.travelTimeRateMessage = 'Value cannot be empty.';
        flag = false;
      } else if (isNaN(Number(this.editUser_travelTimeRate.trim()))) {
        this.editUser_errors.travelTimeRateError = true;
        this.editUser_errors.travelTimeRateMessage = 'Value is not a decimal.';
        flag = false;
      } else {
        this.editUser_errors.travelTimeRateError = false;
        this.editUser_errors.travelTimeRateMessage = null;
      }
      return flag;
    },
    clearAddUserModal: function () {
      this.addUser_name = null;
      this.addUser_email = null;
      this.addUser_confirmEmail = null;
      this.addUser_selectedPositions = [];
      this.addUser_billableRate = null;
      this.addUser_payrollRate = null;
      this.addUser_payrollOvertimeRate = null;
      this.addUser_overtimeRate = null;
      this.addUser_travelTimeRate = null;
      this.addUser_billableFlag = false;
      this.addUser_overtimeFlag = false;
      this.addUser_travelFlag = false;
      this.addUser_payrollOvertimeFlag = false;

      //clear errors
      this.addUser_errors.nameError = false;
      this.addUser_errors.nameMessage = null;
      this.addUser_errors.emailError = false;
      this.addUser_errors.emailMessage = null;
      this.addUser_errors.confirmEmailError = false;
      this.addUser_errors.confirmEmailMessage = null;
      this.addUser_errors.positionsError = false;
      this.addUser_errors.positionsMessage = null;
      this.addUser_errors.billableRateError = false;
      this.addUser_errors.billableRateMessage = null;
      this.addUser_errors.overtimeRateError = false;
      this.addUser_errors.overtimeRateMessage = null;
      this.addUser_errors.travelTimeRateError = false;
      this.addUser_errors.travelTimeRateMessage = null;
      this.addUser_errors.payrollRateError = false;
      this.addUser_errors.payrollRateMessage = null;
      this.addUser_errors.payrollOvertimeRateError = false;
      this.addUser_errors.payrollOvertimeRateMessage = null;
    },
    clearEditUserModal: function () {
      this.editUser_name = null;
      this.editUser_email = null;
      this.editUser_confirmEmail = null;
      this.editUser_selectedPositions = [];
      this.editUser_billableRate = null;
      this.editUser_payrollRate = null;
      this.editUser_payrollOvertimeRate = null;
      this.editUser_overtimeRate = null;
      this.editUser_travelTimeRate = null;

      //clear errors
      this.editUser_errors.nameError = false;
      this.editUser_errors.nameMessage = null;
      this.editUser_errors.emailError = false;
      this.editUser_errors.emailMessage = null;
      this.editUser_errors.confirmEmailError = false;
      this.editUser_errors.confirmEmailMessage = null;
      this.editUser_errors.positionsError = false;
      this.editUser_errors.positionsMessage = null;
      this.editUser_errors.billableRateError = false;
      this.editUser_errors.billableRateMessage = null;
      this.editUser_errors.overtimeRateError = false;
      this.editUser_errors.overtimeRateMessage = null;
      this.editUser_errors.travelTimeRateError = false;
      this.editUser_errors.travelTimeRateMessage = null;
      this.editUser_errors.payrollRateError = false;
      this.editUser_errors.payrollRateMessage = null;
      this.editUser_errors.payrollOvertimeRateError = false;
      this.editUser_errors.payrollOvertimeRateMessage = null;
    },
    addCustomer: function () {
      if (this.validateAddCustomer()) {
        //if the sage integration is active, then we will call the cloud function. If the integration isn't active, then we won't call the cloud function.
        //integration is not active.
        addCustomer(
          this.addCustomer_name,
          this.sageIntegration.customers,
          this.qbIntegration.customers
        )
          .then((doc) => {
            if (this.sageIntegration.customers) {
              //sage active
              if (doc.status == 200) {
                this.customersTableData.push({
                  edit: doc.id,
                  name: this.addCustomer_name,
                  source: 'Sage',
                });
                Vue.$toast.open({
                  message: 'Customer added successfully.',
                  type: 'success',
                  duration: 4000,
                  position: 'top-right',
                });
                this.$refs.collectionTableChild.clearAddInput();
              } else {
                Swal.fire(
                  'Error!',
                  'An error was encountered while adding the customer.',
                  'error'
                );
                // Swal.fire('Error!', 'An unhandled error occurred! 🤔', 'error');
              }
            } else if (this.qbIntegration.customers) {
              if (doc.status == 200) {
                this.customersTableData.push({
                  edit: doc.id,
                  name: this.addCustomer_name,
                  source: 'QuickBooks',
                });
                Vue.$toast.open({
                  message: 'Customer added successfully.',
                  type: 'success',
                  duration: 4000,
                  position: 'top-right',
                });
                this.$refs.collectionTableChild.clearAddInput();
              } else {
                Swal.fire(
                  'Error!',
                  'An error was encountered while adding the customer.',
                  'error'
                );
                // Swal.fire('Error!', 'An unhandled error occurred! 🤔', 'error');
              }
            } else {
              //sage not active.
              this.customersTableData.push({
                edit: doc.id,
                name: this.addCustomer_name,
                source: 'Kali',
              });
              Vue.$toast.open({
                message: 'Customer added successfully.',
                type: 'success',
                duration: 4000,
                position: 'top-right',
              });
              this.$refs.collectionTableChild.clearAddInput();
              // Swal.fire('Success!', 'Customer added successfully.', 'success');
            }
          })
          .catch((err) => {
            if (
              err.response.status == 500 &&
              err.response.data.response == 'Token expired'
            ) {
              //check to see what integration we are working with, and get a new token from that API.
              if (this.sageIntegration.customers) {
                //refresh the token.
                let sendParams = {
                  refresh_token: `${sessionStorage.getItem(
                    'sage_refresh_token'
                  )}`,
                  org: sessionStorage.getItem('org'),
                };
                //axios.get(`http://localhost:5000/kali-45420/us-central1/refreshSageToken`, {
                axios
                  .get(
                    `https://us-central1-kali-45420.cloudfunctions.net/refreshSageToken`,
                    {
                      params: {
                        sendParams,
                      },
                    }
                  )
                  .then(async (response) => {
                    let success = await updateSageIntegrationDetails(
                      response.data.response.access_token,
                      response.data.response.refresh_token,
                      sessionStorage.getItem('sage_invoicing'),
                      sessionStorage.getItem('sage_customers'),
                      sessionStorage.getItem('sage_inventory')
                    );
                    if (success) {
                      this.addCustomer();
                    } else {
                      console.log('error updating sage integration details.');
                    }
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              } else if (this.qbIntegration.customers) {
                console.log('token expired');
                //refresh the token.
                let sendParams = {
                  refresh_token: `${sessionStorage.getItem(
                    'qb_refresh_token'
                  )}`,
                  org: sessionStorage.getItem('org'),
                  realmId: sessionStorage.getItem('qb_realmId'),
                };
                axios
                  .get(
                    `https://us-central1-kali-45420.cloudfunctions.net/refreshQBToken`,
                    {
                      // axios.get(`http://localhost:5000/kali-45420/us-central1/refreshQBToken`, {
                      params: {
                        sendParams,
                      },
                    }
                  )
                  .then(async (response) => {
                    let success = await updateQBOIntegrationDetails(
                      response.data.response.access_token,
                      response.data.response.refresh_token,
                      sessionStorage.getItem('qb_invoicing'),
                      sessionStorage.getItem('qb_customers'),
                      sessionStorage.getItem('qb_realmId')
                    );
                    if (success) {
                      this.addCustomer();
                    } else {
                      console.log('error updating sage integration details.');
                    }
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }
            } else {
              console.log(`Error adding customer : ${err}`);
              Swal.fire('Error!', 'Error adding the customer.', 'error');
            }
          });
      }
      //  else {
      //   bvModalEvt.preventDefault();
      // }
    },
    validateAddCustomer: function () {
      let flag = true;
      if (this.addCustomer_name == null || this.addCustomer_name.trim() == '') {
        this.addCustomer_errors.customerError = true;
        this.addCustomer_errors.customerMessage = 'Value cannot be empty.';
        flag = false;
      } else {
        this.addCustomer_errors.customerError = false;
        this.addCustomer_errors.customerMessage = null;
      }
      return flag;
    },
    editCustomer: function (index, id, name) {
      this.editCustomer_index = index;
      this.editCustomer_id = id;
      this.editCustomer_name = name;
    },
    validateEditCustomer: function () {
      let flag = true;
      if (
        this.editCustomer_name == null ||
        this.editCustomer_name.trim() == ''
      ) {
        this.editCustomer_errors.customerError = true;
        this.editCustomer_errors.customerMessage = 'Value cannot be empty.';
        flag = false;
      } else {
        this.editCustomer_errors.customerError = false;
        this.editCustomer_errors.customerMessage = null;
      }
      return flag;
    },
    submitEditCustomer: function (bvModalEvt) {
      if (this.validateEditCustomer()) {
        firestore()
          .collection('customers')
          .doc(this.editCustomer_id)
          .update({
            customerName: this.editCustomer_name.toLowerCase(),
            displayName: this.editCustomer_name,
          })
          .then(() => {
            //apparently updating arrays by index does not keep the reactivity, so we need to splice a new value into the array.
            this.customersTableData.splice(this.editCustomer_index, 1, {
              edit: this.editCustomer_id,
              name: this.editCustomer_name,
            });
            Swal.fire('Success!', 'The udpate was successful.', 'success');
          })
          .catch(() => {
            Swal.fire(
              'Error!',
              'An error was encountered when updating the record.',
              'error'
            );
          });
      } else {
        bvModalEvt.preventDefault();
      }
    },
    sendPasswordReset: function (email) {
      this.loading = true;
      try {
        auth()
          .sendPasswordResetEmail(email)
          .then(() => {
            console.log(
              `Password reset email was sent for user with email: ${email}`
            );
            this.loading = false;
            Swal.fire(
              'Success!',
              'User has been sent the password reset email. This email is valid for 1 hour.',
              'success'
            );
          })
          .catch((error) => {
            this.loading = false;
            console.log(`Error resetting users password:`);
            console.log(error);
            Swal.fire('Error!', error.message, 'error');
          });
      } catch (err) {
        this.loading = false;
        console.log(
          `An unexpected error was encountered when calling the password reset function: ${err}`
        );
        Swal.fire('Error!', err.response.data.response, 'error');
      }
    },
    deleteCustomer: function (id, sage_id, qb_id, qb_sync_token) {
      //if the sage integration is active, then we also need to delete the customer from the db.
      if (
        this.sageIntegration.active &&
        this.sageIntegration.customers &&
        sage_id != null
      ) {
        this.deleteSageContact(id, sage_id);
      } else if (
        this.qbIntegration.active &&
        this.qbIntegration.customers &&
        qb_id != null
      ) {
        //check to see if this customer is actually a qbo customer first.
        this.deleteQBContact(id, qb_id, qb_sync_token);
      } else {
        firestore()
          .collection('customers')
          .doc(id)
          .delete()
          .then(() => {
            this.customersTableData = this.customersTableData.filter(function (
              obj
            ) {
              return obj.edit !== id;
            });
            Vue.$toast.open({
              message: 'The selected customer was successfully deleted.',
              type: 'success',
              duration: 4000,
              position: 'top-right',
            });
          })
          .catch(() => {
            Swal.fire(
              'Error!',
              'An error was encountered when deleteing the record.',
              'error'
            );
          });
      }
    },
    deactivateUser: function (id) {
      this.deleteUserLoading = true;
      //send the request to the server.
      let request = {
        uid: `${id}`,
      };
      // axios.get('http://localhost:5000/kali-45420/us-central1/deactivateUser', {
      axios
        .get(
          'https://us-central1-kali-45420.cloudfunctions.net/deactivateUser',
          {
            params: {
              request,
            },
          }
        )
        .then((response) => {
          if (response.status == 200) {
            Swal.fire('Success!', 'User successfully deleted.', 'success');
            this.getEmployees();
            this.deleteUserLoading = false;
          } else {
            Swal.fire('Error!', 'An unhandled error occurred! 🤔', 'error');
            this.deleteUserLoading = false;
          }
        })
        .catch((err) => {
          console.log(`Error calling the add user function: ${err}`);
          console.log(err);
          Swal.fire('Error!', err.toString(), 'error');
          this.deleteUserLoading = false;
        });
    },
    getEmployees: function () {
      this.usersTableData = [];
      getEmployees()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let obj = {
              edit: doc.id,
              employee: doc.data().displayName,
              position: doc.data().position,
              payrollRate: doc.data().payrollRate,
              payrollOvertimeRate: doc.data().payrollOvertimeRate,
              billableRate: doc.data().rate,
              overtimeRate: doc.data().overtimeRate,
              travelTimeRate: doc.data().travelTimeRate,
              UID: doc.data().auth,
              email: doc.data().email,
            };
            this.usersTableData.push(obj);
            this.usersTotalRows = this.usersTableData.length
          });
        })
        .catch((error) => {
          console.log(`Error getting user list. ${error}`);
        });
    },
    getSageCustomers: async function () {
      if (this.timeOutCounter <= 3) {
        let sendParams = {
          access_token: `${sessionStorage.getItem('sage_access_token')}`,
          refresh_token: `${sessionStorage.getItem('sage_refresh_token')}`,
          org: sessionStorage.getItem('org'),
        };
        axios
          .get(`http://localhost:5000/kali-45420/us-central1/getSageContacts`, {
            //axios.get(`https://us-central1-kali-45420.cloudfunctions.net/getSageContacts`, {
            params: {
              sendParams,
            },
          })
          .then((response) => {
            console.log(response);
            let inventoryData = response.data.items;
            console.log(inventoryData);
            this.getCustomerCallBack();
          })
          .catch((err) => {
            //check to see if the status code is 500. If it is, try to retrieve the updated tokens from the db.
            if (
              err.response.status == 500 &&
              err.response.data.response == 'Token expired'
            ) {
              //refresh the token.
              let sendParams = {
                refresh_token: `${sessionStorage.getItem(
                  'sage_refresh_token'
                )}`,
                org: sessionStorage.getItem('org'),
              };
              //axios.get(`http://localhost:5000/kali-45420/us-central1/refreshSageToken`, {
              axios
                .get(
                  `https://us-central1-kali-45420.cloudfunctions.net/refreshSageToken`,
                  {
                    params: {
                      sendParams,
                    },
                  }
                )
                .then(async (response) => {
                  // let success = await updateSageIntegrationDetails(response.data.response.access_token, response.data.response.refresh_token, this.$store.state.custom.sageIntegration.invoicing, this.$store.state.custom.sageIntegration.customers, this.$store.state.custom.sageIntegration.inventory)
                  let success = await updateSageIntegrationDetails(
                    response.data.response.access_token,
                    response.data.response.refresh_token,
                    sessionStorage.getItem('sage_invoicing'),
                    sessionStorage.getItem('sage_customers'),
                    sessionStorage.getItem('sage_inventory')
                  );
                  if (success) {
                    this.getSageCustomers();
                  } else {
                    console.log('error updating sage integration details.');
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            } else {
              console.log(`Error getting the customers data set`);
              Swal.fire(
                'Error!',
                'Error getting the customers data set.',
                'error'
              );
            }
          });
      }
    },
    updateSage: function () {
      Swal.fire({
        title: 'Enable customer integration for Sage?',
        text: 'Customer data will be automatically synced with Sage. Creating, editing, and deleting customer data in both Sage and Kali will be reflected in both.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#34c38f',
        cancelButtonColor: '#f46a6a',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          //update the sage integration to have inventory active.
          //update the state and the db.
          firestore()
            .collection('organizations')
            .doc(sessionStorage.getItem('org'))
            .collection('integrations')
            .get()
            .then((querySnapshot) => {
              let id;
              querySnapshot.forEach((doc) => {
                //update the doc if it is the sage integration.
                id = doc.id;
              });
              return id;
            })
            .then((id) => {
              //update the document.
              firestore()
                .collection('organizations')
                .doc(sessionStorage.getItem('org'))
                .collection('integrations')
                .doc(id)
                .update({
                  sage: {
                    active: true,
                    invoicing: parseBoolFromString(
                      sessionStorage.getItem('sage_invoicing')
                    ),
                    customers: true,
                    inventory: parseBoolFromString(
                      sessionStorage.getItem('sage_inventory')
                    ),
                    access_token: sessionStorage.getItem('sage_access_token'),
                    refresh_token: sessionStorage.getItem('sage_refresh_token'),
                  },
                })
                .then(() => {
                  try {
                    //update the sage integration details.
                    this.updateSageStatus({
                      sageStatus: {
                        active: true,
                        invoicing: parseBoolFromString(
                          sessionStorage.getItem('sage_invoicing')
                        ),
                        customers: true,
                        inventory: parseBoolFromString(
                          sessionStorage.getItem('sage_inventory')
                        ),
                      },
                    });
                    this.sageIntegration.customers = true;
                    sessionStorage.setItem('sage_customers', true);
                    Swal.fire(
                      'Success!',
                      'Sage integration successfully configured.',
                      'success'
                    );
                  } catch (err) {
                    console.log(err);
                    Swal.fire(
                      'Error!',
                      'Error configuring Sage integration.',
                      'error'
                    );
                  }
                })
                .catch((err) => {
                  console.log(err);
                  Swal.fire(
                    'Error!',
                    'Error configuring Sage integration.',
                    'error'
                  );
                });
            })
            .catch((err) => {
              console.log(err);
              Swal.fire(
                'Error!',
                'Error configuring Sage integration.',
                'error'
              );
            });
        }
      });
    },
    deleteSageContact: function (id, sage_id) {
      if (this.timeOutCounter <= 3) {
        //send the request to the cloud function to delete the customer.
        let sendParams = {
          id: id,
          sage_id: sage_id,
          org: sessionStorage.getItem('org'),
          access_token: sessionStorage.getItem('sage_access_token'),
        };
        axios
          .get(
            'http://localhost:5000/kali-45420/us-central1/deleteCustomerFromSage',
            {
              params: {
                sendParams,
              },
            }
          )
          .then(() => {
            //the delete was successful.
            this.customersTableData = this.customersTableData.filter(function (
              obj
            ) {
              return obj.edit !== id;
            });
            Swal.fire(
              'Deleted!',
              'The selected customer was successfully deleted.',
              'success'
            );
          })
          .catch((err) => {
            if (
              err.response.status == 500 &&
              err.response.data.response == 'Token expired'
            ) {
              //refresh the token.
              let sendParams = {
                refresh_token: `${sessionStorage.getItem(
                  'sage_refresh_token'
                )}`,
                org: sessionStorage.getItem('org'),
              };
              //axios.get(`http://localhost:5000/kali-45420/us-central1/refreshSageToken`, {
              axios
                .get(
                  `https://us-central1-kali-45420.cloudfunctions.net/refreshSageToken`,
                  {
                    params: {
                      sendParams,
                    },
                  }
                )
                .then(async (response) => {
                  let success = await updateSageIntegrationDetails(
                    response.data.response.access_token,
                    response.data.response.refresh_token,
                    sessionStorage.getItem('sage_invoicing'),
                    sessionStorage.getItem('sage_customers'),
                    sessionStorage.getItem('sage_inventory')
                  );
                  if (success) {
                    this.deleteSageContact();
                  } else {
                    console.log('error updating sage integration details.');
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            } else {
              console.log(`Error deleting customer from Sage: ${err}`);
              Swal.fire('Error!', 'Error deleting the customer.', 'error');
            }
          });
      }
    },
    deleteQBContact: function (id, qb_id, qb_sync_token) {
      if (this.timeOutCounter <= 3) {
        //send the request to the cloud function to delete the customer.
        let sendParams = {
          id: id,
          qb_id: qb_id,
          sync_token: qb_sync_token,
          org: sessionStorage.getItem('org'),
          access_token: sessionStorage.getItem('qb_access_token'),
          realmId: sessionStorage.getItem('qb_realmId'),
        };
        axios
          .get(
            'https://us-central1-kali-45420.cloudfunctions.net/deactivateCustomerFromQB',
            {
              // axios
              //   .get(
              //     'http://localhost:5000/kali-45420/us-central1/deactivateCustomerFromQB',
              //     {
              params: {
                sendParams,
              },
            }
          )
          .then(() => {
            Vue.$toast.open({
              message: 'Customer successfully deleted.',
              type: 'success',
              duration: 4000,
              position: 'top-right',
            });
            //the delete was successful.
            this.customersTableData = this.customersTableData.filter(function (
              obj
            ) {
              return obj.edit !== id;
            });
          })
          .catch((err) => {
            if (
              err.response.status == 500 &&
              err.response.data.response == 'Token expired'
            ) {
              console.log('token expired');
              //refresh the token.
              let sendParams = {
                refresh_token: `${sessionStorage.getItem('qb_refresh_token')}`,
                org: sessionStorage.getItem('org'),
                realmId: sessionStorage.getItem('qb_realmId'),
              };
              axios
                .get(
                  `https://us-central1-kali-45420.cloudfunctions.net/refreshQBToken`,
                  {
                    // axios.get(`http://localhost:5000/kali-45420/us-central1/refreshQBToken`, {
                    params: {
                      sendParams,
                    },
                  }
                )
                .then(async (response) => {
                  let success = await updateQBOIntegrationDetails(
                    response.data.response.access_token,
                    response.data.response.refresh_token,
                    sessionStorage.getItem('qb_invoicing'),
                    sessionStorage.getItem('qb_customers'),
                    sessionStorage.getItem('qb_realmId')
                  );
                  if (success) {
                    this.deleteQBContact();
                  } else {
                    console.log('error updating sage integration details.');
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            } else {
              console.log(err.response);
              console.log(`Error deleting customer from Sage: ${err.response}`);
              Swal.fire(
                'Error!',
                `Error deleting the customer: ${err.response.data.response}`,
                'error'
              );
            }
          });
      }
    },
    getCustomerCallBack: function () {
      this.customersTableData = [];
      this.customersTotalRows = 0;
      (this.customersFields = [
        { key: 'edit', label: '', sortable: false },
        { key: 'name', sortable: true },
        { key: 'source', sortable: true },
      ]),
        getCustomers()
          .then((querySnapshot) => {
            querySnapshot.forEach((customer) => {
              //calculate the source of the object.
              let source = 'Kali';
              if (customer.data().sage_id != undefined) {
                source = 'Sage';
              } else if (customer.data().qb_id != undefined) {
                source = 'QuickBooks';
              }

              let obj = {
                edit: customer.id,
                name: customer.data().displayName,
                source: source,
                sage_id:
                  customer.data().sage_id != undefined
                    ? customer.data().sage_id
                    : null,
                qb_id:
                  customer.data().qb_id != undefined
                    ? customer.data().qb_id
                    : null,
                qb_sync_token:
                  customer.data().qb_sync_token != undefined
                    ? customer.data().qb_sync_token
                    : null,
              };
              this.customersTableData.push(obj);
              this.customersTotalRows++;
            });
          })
          .catch(() => {
            console.log(`Error getting customers list`);
          });
    },
    getQBCustomers: function () {
      syncQBCustomers()
        .then(() => {
          this.getCustomerCallBack();
          Swal.fire(
            'Success!',
            'QuickBooks customers successfully synced.',
            'success'
          );
        })
        .catch((err) => {
          //check to see if the status code is 500. If it is, try to retrieve the updated tokens from the db.
          if (
            err.response.status == 401 &&
            err.response.data.response == 'Token expired'
          ) {
            console.log('token expired');
            //refresh the token.
            let sendParams = {
              refresh_token: `${sessionStorage.getItem('qb_refresh_token')}`,
              org: sessionStorage.getItem('org'),
              realmId: sessionStorage.getItem('qb_realmId'),
            };
            axios
              .get(
                `https://us-central1-kali-45420.cloudfunctions.net/refreshQBToken`,
                {
                  // axios
                  //   .get(
                  //     `http://localhost:5000/kali-45420/us-central1/refreshQBToken`,
                  //     {
                  params: {
                    sendParams,
                  },
                }
              )
              .then(async (response) => {
                let success = await updateQBOIntegrationDetails(
                  response.data.response.access_token,
                  response.data.response.refresh_token,
                  sessionStorage.getItem('qb_invoicing'),
                  sessionStorage.getItem('qb_customers'),
                  sessionStorage.getItem('qb_realmId')
                );
                if (success) {
                  this.getQBCustomers();
                } else {
                  console.log('error updating QuickBooks integration details.');
                }
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            console.log(err);
            console.log(`Error getting the QuickBooks customers data set`);
            Swal.fire(
              'Error!',
              'Error getting the QuickBooks customers data set.',
              'error'
            );
          }
        });
    },
    getQBCustomersOnLoad: function () {
      syncQBCustomers()
        .then(() => {
          this.getCustomerCallBack();
        })
        .catch((err) => {
          //check to see if the status code is 500. If it is, try to retrieve the updated tokens from the db.
          if (
            err.response.status == 401 &&
            err.response.data.response == 'Token expired'
          ) {
            console.log('token expired');
            //refresh the token.
            let sendParams = {
              refresh_token: `${sessionStorage.getItem('qb_refresh_token')}`,
              org: sessionStorage.getItem('org'),
              realmId: sessionStorage.getItem('qb_realmId'),
            };
            axios
              .get(
                `https://us-central1-kali-45420.cloudfunctions.net/refreshQBToken`,
                {
                  // axios
                  //   .get(
                  //     `http://localhost:5000/kali-45420/us-central1/refreshQBToken`,
                  // {
                  params: {
                    sendParams,
                  },
                }
              )
              .then(async (response) => {
                let success = await updateQBOIntegrationDetails(
                  response.data.response.access_token,
                  response.data.response.refresh_token,
                  sessionStorage.getItem('qb_invoicing'),
                  sessionStorage.getItem('qb_customers'),
                  sessionStorage.getItem('qb_realmId')
                );
                if (success) {
                  this.getQBCustomersOnLoad();
                } else {
                  console.log('error updating QuickBooks integration details.');
                }
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            console.log(err);
            console.log(`Error getting the QuickBooks customers data set`);
            Swal.fire(
              'Error!',
              'Error getting the QuickBooks customers data set.',
              'error'
            );
          }
        });
    },
    deleteCollectionItem: function (params) {
      if (this.collectionSelection.name == 'Customers') {
        //call the delete customer function.
        this.deleteCustomer(
          params.edit,
          params.sage_id,
          params.qb_id,
          params.qb_sync_token
        );
      } else {
        //since the add function is just updating the values field in the colleciton, we can remove the
        //value from the array and call the add function and it will delete the item from the collection.
        this.customersTableData.splice(params.index, 1);
        let newArray = this.customersTableData.map((o) => o.name);

        addCustomCollectionItem(this.collectionSelection, newArray)
          .then(() => {
            Vue.$toast.open({
              message: 'Item delete from collection',
              type: 'success',
              duration: 4000,
              position: 'top-right',
            });
          })
          .catch(() => {
            Swal.fire(
              'Error!',
              'An error was encountered while deleting the item from the collection.',
              'error'
            );
          });
      }
    },
    addCollectionItem: function (item) {
      //check what collection we are in.
      if (this.collectionSelection.name == 'Customers') {
        //if it is the customers selection, then we follow the customers logic, as there
        //are integrations we need to handle, like sage and quickbooks.
        this.addCustomer_name = item;
        this.addCustomer();
      } else {
        //add the item to the selected collection and udpate the table data.
        let index = this.customersTableData.find((o) => o.name == item);

        if (index != undefined) {
          Vue.$toast.open({
            message: 'Item already exists in the collection.',
            type: 'error',
            duration: 4000,
            position: 'top-right',
          });
        } else {
          let newArray = this.customersTableData.map((o) => o.name);

          //add the new item to the array.
          newArray.push(item);

          addCustomCollectionItem(this.collectionSelection, newArray)
            .then(() => {
              Vue.$toast.open({
                message: 'Item added to collection',
                type: 'success',
                duration: 4000,
                position: 'top-right',
              });
              //update the item collection, so the new item will show in the table.
              this.customersTableData.push({
                edit: '',
                name: item,
              });

              //clear the add input.
              this.$refs.collectionTableChild.clearAddInput();
            })
            .catch(() => {
              Swal.fire(
                'Error!',
                'An error was encountered while adding the item to the collection.',
                'error'
              );
            });
        }
      }
    },
    updateCollectionSelection: function (collection) {
      //this function is emitted by the collections sidebar.

      this.customersTableData = [];
      this.collectionSelection = {
        id: collection.id,
        name: collection.name,
      };
      //go get the collection data and update the collection table.
      //check to see if this is the customers selection:
      if (this.collectionSelection.name == 'Customers') {
        if (this.sageIntegration.active && this.sageIntegration.customers) {
          this.getSageCustomers();
        } else if (this.qbIntegration.active && this.qbIntegration.customers) {
          this.getQBCustomersOnLoad();
        } else {
          this.getCustomerCallBack();
        }
      } else {
        getCustomCollectionData(collection)
          .then((doc) => {
            this.customersFields = [
              { key: 'edit', label: '', sortable: false },
              { key: 'name', sortable: true },
            ];
            let records = doc.data().values;
            if (records != undefined && records.length >= 1) {
              records.forEach((record) => {
                this.customersTableData.push({
                  edit: '',
                  name: record,
                });
              });
            }
          })
          .catch(() => {
            Swal.fire(
              'Error!',
              'An error was encountered while getting collection data.',
              'error'
            );
          });
      }
    },
    deleteCollection: function () {
      if (
        this.collectionSelection.id != null &&
        this.collectionSelection.id != undefined
      ) {
        deleteCustomCellection(this.collectionSelection.id)
          .then(() => {
            //change to customers selection and remove the current selection from the sidebar.
            let selectedCollection = {
              id: null,
              name: 'Customers',
            };
            this.$refs.collectionsSidePanel.populateCollections();
            this.$refs.collectionsSidePanel.changeSelection(selectedCollection);
            // this.updateCollectionSelection(selectedCollection);
          })
          .catch(() => {
            Swal.fire(
              'Error!',
              'An error was encountered while deleting the collection.',
              'error'
            );
          });
      }
    },
    populateEditUser: function (index) {
      let employee = this.usersTableData[index];

      this.editUser_index = index;
      this.editUser_ID = employee.edit;
      this.editUser_name = employee.employee;
      this.editUser_email = employee.email;
      this.editUser_confirmEmail = employee.email;
      for (let i = 0; i < employee.position.length; i++) {
        this.editUser_selectedPositions[i] = employee.position[i];
      }
      this.editUser_billableRate = employee.billableRate;
      this.editUser_payrollRate = employee.payrollRate;
      this.editUser_payrollOvertimeRate = employee.payrollOvertimeRate;
      this.editUser_overtimeRate = employee.overtimeRate;
      this.editUser_travelTimeRate = employee.travelTimeRate;
    },
    editUser: async function (bvModalEvt) {
      this.loading = true;
      //if the inputs are all valid update the firestore, update the userstabledata to update the table and then update the firebase auth email
      if (this.validateEditUser()) {
        try {
          await firebase
            .firestore()
            .collection('employees')
            .doc(this.editUser_ID)
            .update({
              displayName: this.editUser_name,
              email: this.editUser_email,
              name: this.editUser_name.toLowerCase(),
              position: this.editUser_selectedPositions,
              payrollRate: this.editUser_payrollRate,
              payrollOvertimeRate: this.editUser_payrollOvertimeRate,
              rate: this.editUser_billableRate,
              overtimeRate: this.editUser_overtimeRate,
              travelTimeRate: this.editUser_travelTimeRate,
            })
            .then(() => {
              let previousEmail =
                this.usersTableData[this.editUser_index].email;
              let previousName = this.usersTableData[this.editUser_index]
                .employee;
              let fallbackData = this.usersTableData[this.editUser_index];

              //the table would not update unless I remove and re-add the element,

              this.usersTableData.splice(this.editUser_index, 1);
              this.usersTableData.splice(this.editUser_index, 0, {
                edit: this.editUser_ID,
                employee: this.editUser_name,
                position: this.editUser_selectedPositions,
                payrollRate: this.editUser_payrollRate,
                payrollOvertimeRate: this.editUser_payrollOvertimeRate,
                billableRate: this.editUser_billableRate,
                overtimeRate: this.editUser_overtimeRate,
                travelTimeRate: this.editUser_travelTimeRate,
                UID: this.editUser_ID,
                email: this.editUser_email,
              });

              if (this.editUser_email !== previousEmail || this.editUser_name !== previousName) {
                let request = {
                  uid: `${this.editUser_ID}`,
                  email: `${this.editUser_email}`,
                  displayName: `${this.editUser_name}`,
                };
                axios
                  .get(
                    'https://us-central1-kali-45420.cloudfunctions.net/updateUser',
                    // 'http://localhost:5000/kali-45420/us-central1/updateUser',

                    {
                      params: {
                        request,
                      },
                    }
                  )
                  .then((response) => {
                    if (response.status == 200) {
                      this.loading = false;
                      Swal.fire(
                        'Success!',
                        'User edited successfully.',
                        'success'
                      );
                      this.$bvModal.hide('modal_editUser');
                    }
                  })
                  .catch(async (err) => {
                    this.loading = false;
                    //if firebase auth email update fails, roll back data in database
                    console.log(`Error calling the edit user function: ${err}`);
                    Swal.fire('Error updating user.', `${err}`, 'error');

                    try {
                      await firebase
                        .firestore()
                        .collection('employees')
                        .doc(this.editUser_ID)
                        .update({
                          displayName: fallbackData.employee,
                          email: fallbackData.email,
                          name: fallbackData.employee.toLowerCase(),
                          position: fallbackData.position,
                          payrollRate: fallbackData.payrollRate,
                          payrollOvertimeRate: fallbackData.payrollOvertimeRate,
                          rate: fallbackData.rate,
                          overtimeRate: fallbackData.overtimeRate,
                          travelTimeRate: fallbackData.travelTimeRate,
                        })
                        .then(() => {
                          this.usersTableData.splice(this.editUser_index, 1);
                          this.usersTableData.splice(this.editUser_index, 0, {
                            edit: this.editUser_ID,
                            employee: fallbackData.employee,
                            position: fallbackData.position,
                            payrollRate: fallbackData.payrollRate,
                            payrollOvertimeRate:
                              fallbackData.payrollOvertimeRate,
                            rate: fallbackData.rate,
                            overtimeRate: fallbackData.overtimeRate,
                            travelTimeRate: fallbackData.travelTimeRate,
                            UID: this.editUser_ID,
                            email: fallbackData.email,
                          });
                        });
                    } catch (error) {
                      this.loading = false;
                      console.log(error);
                      Swal.fire(
                        'Error updating user email. Out of Sync. Please contact support',
                        `${err}`,
                        'error'
                      );
                    }
                  });
              } else {
                this.loading = false;
                Swal.fire('Success!', 'User edited successfully.', 'success');
                this.$bvModal.hide('modal_editUser');
              }
            })

            .catch((err) => {
              this.loading = false;
              console.log(`Error calling the edit user function: ${err}`);
              Swal.fire('Error!', `${err}`, 'error');
            });
        } catch (error) {
          this.loading = false;
          console.log(`Error editing user.`, error);
          Swal.fire(
            'Error!',
            'An error was encountered when editing the user.',
            'error'
          );
        }
        this.clearEditUserModal();
      } else {
        this.loading = false;
        bvModalEvt.preventDefault();
      }
    },
    separateInputFromPayroll(input) {
      if (input === 'billable') {
        this.addUser_billableFlag = true;
      } else if (input === 'overtime') {
        this.addUser_overtimeFlag = true;
      } else if (input === 'payrollOvertime') {
        this.addUser_payrollOvertimeFlag = true;
      } else if (input === 'travel') {
        this.addUser_travelFlag = true;
      }
    },
    setTableSettings: function () {
      if (this.currentUser.tablePageLengths) {
        if (this.currentUser.tablePageLengths.perPage_adminUsers) {
          this.usersPerPage =
            this.currentUser.tablePageLengths.perPage_adminUsers;
        }
      }
    },
  },

  computed: {
    sageIntegration: function () {
      return {
        customers: parseBoolFromString(
          sessionStorage.getItem('sage_customers')
        ),
        active: parseBoolFromString(sessionStorage.getItem('sage_active')),
      };
    },
    qbIntegration: function () {
      return {
        customers: parseBoolFromString(sessionStorage.getItem('qb_customers')),
        active: parseBoolFromString(sessionStorage.getItem('qb_active')),
      };
    },
  },
  mounted() {
    this.getEmployees();

    //if we have an integration active, then just call that function instead of the default get customers function
    if (this.sageIntegration.active && this.sageIntegration.customers) {
      this.getSageCustomers();
    } else if (this.qbIntegration.active && this.qbIntegration.customers) {
      this.getQBCustomersOnLoad();
    } else {
      this.getCustomerCallBack();
    }

    getPositions()
      .then((querySnapshot) => {
        querySnapshot.forEach((position) => {
          this.positions.push(position.data().name);
        });
      })
      .catch(() => {
        console.log(`Error getting positions list`);
      });
    this.setTableSettings();
  },
  watch: {
    addUser_payrollRate(val) {
      //change all rates that have not been edited when the Employee Rate field is filled out.
      if (this.addUser_billableFlag !== true) {
        this.addUser_billableRate = val;
      }
      if (this.addUser_overtimeFlag !== true) {
        this.addUser_overtimeRate = val;
      }
      if (this.addUser_travelFlag !== true) {
        this.addUser_travelTimeRate = val;
      }
      if (this.addUser_payrollOvertimeFlag !== true) {
        this.addUser_payrollOvertimeRate = val;
      }
    },
    usersPerPage(newVal, oldVal) {
      // make sure current user is updated
      this.currentUser = this.$store.state.custom.currentUserData;

      if (newVal !== oldVal) {
        let currentUserDataCopy = JSON.parse(JSON.stringify(this.currentUser));
        let oldCurrentUserPerPage = null;

        if (currentUserDataCopy.tablePageLengths) {
          if(currentUserDataCopy.tablePageLengths.perPage_adminUsers){
            oldCurrentUserPerPage = currentUserDataCopy.tablePageLengths.perPage_adminUsers;
          }
          currentUserDataCopy.tablePageLengths['perPage_adminUsers'] = newVal;
        } else {
          currentUserDataCopy['tablePageLengths'] = {
            perPage_adminUsers: newVal,
          };
        }

        if (oldCurrentUserPerPage !== newVal) {
          try {
            firebase
              .firestore()
              .collection('employees')
              .doc(this.currentUser.auth)
              .update({
                tablePageLengths: currentUserDataCopy.tablePageLengths,
              });
          } catch (err) {
            console.log('Error updating user table settings in db: ', err);
          }
        }
        this.currentUser = currentUserDataCopy;
        this.$store.dispatch('custom/updateUserData', currentUserDataCopy);
      }
    },
  },
  created() {
    //Prevents refresh of page
    window.addEventListener('beforeunload', this.preventPageRefresh);
  },
  beforeRouteLeave(to, from, next) {
    //Remove event listener to prevent chrome popup from showing up on other pages
    document.body.removeEventListener('beforeunload', this.preventPageRefresh);
    if (this.showSavePopup) {
      Swal.fire({
        title:
          'Do you want to save your changes? Any unsaved changes will be deleted.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Save Changes',
        cancelButtonText: 'Leave Page',
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$refs.collectionTableChild.updateDatabaseWithDraggableArray();
          next();
        } else {
          this.showSavePopup = false;
          next();
        }
      });
    } else {
      next();
    }
  },
  onFiltered(filteredItems) {
  this.usersTotalRows = filteredItems.length
}
};
</script>
